angular.module('TetherApp').controller('EventReportingController', [
    function () {
        let self = this;

        self.myDate = new Date();

        self.init = function () {

            self.start_date = new Date(
                self.myDate.getFullYear(),
                self.myDate.getMonth() - 1,
                self.myDate.getDate()
            );
            self.start_date_form = self.start_date;

            self.end_date = new Date(
                self.myDate.getFullYear(),
                self.myDate.getMonth(),
                self.myDate.getDate() - 1
            );
            self.end_date_form = self.end_date;

        };

        self.onStartDateChange = function() {
            self.start_date_form = self.start_date;
        };

        self.onEndDateChange = function() {
            self.end_date_form = self.end_date;
        };

    }
]);
